export const DAILY_FUND_ENDPOINT = 'caisse/view';
export const DAILY_FUND_STATE_ENDPOINT = 'caisse/jour';
export const EXPORT_FUND_ENDPOINT = 'caisse/export';
